// Func = limiting Scope for this file
var lastScrollTop = 0;

if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

(function(){

    $(document).ready(function () {

        // Main Nav Dropdown
        $("#primary-nav li").hover(function(){
            $(this).addClass("hover");
            $('ul.submenu',this).fadeIn(200);
        }, function(){
            $(this).removeClass("hover");
            $('ul.submenu',this).fadeOut(200);
        });

		let topContentBar = document.querySelector('.slider-controlers .progressBarContainer');
		let dotOne = document.querySelector('.slider-controlers .swiper-pagination .swiper-pagination-bullet')
		if(topContentBar && dotOne){
			dotOne.parentNode.insertBefore(topContentBar, dotOne.nextSibling);
		}

    });

    window.onload = function() {
		scrollW();
		window.addEventListener('scroll', function(){
			scrollW();
		})
	};
	
	let aBtn = document.querySelectorAll(".btn:not(.attractions-map__expand), .signup-btn");
    if(aBtn){
        aBtn.forEach(function(a_btn) {
            let htmlString = a_btn.innerText;
            a_btn.innerHTML = '<span class="text-btn">'+htmlString+'</span><div class="circle-btn"><span></span></div>';
            a_btn.addEventListener("mouseover", function(evt) {
                let mousePos = oMousePos(a_btn, evt);
                a_btn.querySelector('.circle-btn').style.top = mousePos.y+'px';
                a_btn.querySelector('.circle-btn').style.left = mousePos.x+'px';
            });
            a_btn.addEventListener("mouseout", function(evt) {
                let mousePos = oMousePos(a_btn, evt);
                a_btn.querySelector('.circle-btn').style.top = mousePos.y+'px';
                a_btn.querySelector('.circle-btn').style.left = mousePos.x+'px';
            });
        });
    }


	//// Forms animation for labels   ----------------------------------------------------------------
	//Email signup animation
	if (document.getElementById('email-signup_email_address')) {
		document.getElementById('email-signup_email_address').addEventListener('focus', function () {
			this.parentElement.classList.add('moved');
		});
	}
	if (document.getElementById('email-signup_FNAME')) {
		document.getElementById('email-signup_FNAME').addEventListener('focus', function () {
			this.parentElement.classList.add('moved');
		});
	}
	if (document.getElementById('email-signup_LNAME')) {
		document.getElementById('email-signup_LNAME').addEventListener('focus', function () {
			this.parentElement.classList.add('moved');
		});
	}
	//CMS forms label animation ----------------------------------------------------------------
	if (document.getElementsByClassName('form-module__field').length > 0) {
		const MODULE_FIELDS = document.querySelectorAll('.form-module__field');
		MODULE_FIELDS.forEach((field) => {
			if (field.getElementsByTagName('input').length > 0) {
				if (field.getElementsByTagName('input')[0].type.toLowerCase() != 'checkbox' && field.getElementsByTagName('input')[0].type.toLowerCase() != 'radio') {
					field.getElementsByTagName('input')[0].addEventListener('focus', function () {
						this.parentElement.classList.add('moved');
					});
				}
			}
			if (field.getElementsByTagName('select').length > 0) {
				field.getElementsByTagName('select')[0].addEventListener('focus', function () {
					this.parentElement.classList.add('moved');
				});
			}
			if (field.getElementsByTagName('textarea').length > 0) {
				field.getElementsByTagName('textarea')[0].addEventListener('focus', function () {
					this.parentElement.classList.add('moved');
				});
			}
		});
	}

	// Main Nav Dropdown ----------------------------------------------------------------
	const navItems = document.querySelectorAll('#primary-nav li');
	if(navItems){
		navItems.forEach(function (item) {
			item.addEventListener('mouseover', function () {
				item.classList.add('hover');
				let submenu = item.querySelector('ul.submenu');
				if (submenu) {
					submenu.classList.add('open');
				}
			});
	
			item.addEventListener('mouseout', function () {
				item.classList.remove('hover');
				let submenu = item.querySelector('ul.submenu');
				if (submenu) {
					submenu.classList.remove('open');
				}
			});
		});
	}

    // Remove empty <p> tags created by tinymce
    const paragraph = document.querySelectorAll('p') || [];
	paragraph.forEach( e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));



})();

// Main Site Language ----------------------------------------------------------------
if(document.getElementById('language')){
	document.getElementById('language').addEventListener("change", function(e){
		
		changeLanguage(e.target.value);
	});
}

// burger menu funcionality ----------------------------------------------------------------

const burgerMenu = document.querySelector(".js-burger-menu");
const closeMenu = document.querySelector(".burger-close-js");
const openMenu = document.querySelectorAll(".js-menu-buger");

//Open Menu
openMenu.forEach( cta => {
	cta.addEventListener('click', function (e) {
		e.preventDefault();
		burgerMenu.classList.add("open");
		document.body.classList.add("no-scroll");
	});
});

//Close Menu
closeMenu.addEventListener('click', () => {
	burgerMenu.classList.remove("open");
	document.body.classList.remove("no-scroll");
});

//Menu Burger submenu Funcionality

document.querySelectorAll('.burger-menu__nav > li > a').forEach(link => {
	link.addEventListener('click', e => {
		if (link.nextSibling.nextSibling != null) {
			document.querySelectorAll('.inner > ul > li').forEach(item => {
				if (link.parentNode !== item) item.classList.remove('submenu-show');
			});
			//remove this comment if you want show subnav for mobile
			e.preventDefault();
			link.parentNode.classList.toggle('submenu-show');
			document.querySelector("#mobile-nav-js").classList.toggle('submenu-show')
		}
	});
});

//add class for icon dropdown 
document.querySelectorAll('.burger-menu__nav > li > .sub-sub-menu').forEach(link => {
	let menu = link.parentNode.firstElementChild;
	menu.classList.toggle('ico-dropdown');
})

/* Subnav on mobile */
let submenuHold = document.querySelectorAll('.sub-menu__hold');
let allsublinks = document.querySelectorAll('.sub-menu a');
if(allsublinks.length > 1){
	allsublinks.forEach(ele=>{
		ele.addEventListener('click', function(ev){
			if(ele.classList.contains('active')){
				ev.preventDefault();
			}
		});
	});
	let toggleBtn = document.querySelector('.sub-menu__toggle');
	if(toggleBtn){
		toggleBtn.addEventListener('click', function(){
			toggleBtn.parentElement.classList.toggle('open');
		});
	}
}else if(submenuHold.length > 0){
	submenuHold[0].classList.add('hidden');
}

// Mobile Devices Click Emulator Button


let burgerMenuMobile = document.querySelector('#burgerMenu');
let openMenuBtn = document.querySelector(".js-menu-buger");

if(burgerMenuMobile){
	burgerMenuMobile.addEventListener('click', () => {
		openMenuBtn.click();
	})
}


function scrollW(){
	//check scroll down or up for header styles
	let st = window.pageYOffset || document.documentElement.scrollTop;
	if(st > 80){
		// downscroll code
		if(!document.getElementById('header').classList.contains('scroll')){
			document.getElementById('header').classList.add('scroll');
			document.getElementById('top-content').classList.add('scroll');

			let logoUrl = '/assets/svg/logo-scroll.svg';
			document.getElementsByClassName('header__logo')[0].getElementsByTagName('img')[0].setAttribute('src',logoUrl)

		}
	} else {
		if(document.getElementById('header').classList.contains('scroll')){
			document.getElementById('header').classList.remove('scroll');
			document.getElementById('top-content').classList.remove('scroll');
			
			let logoUrl = '/assets/svg/logo.svg';
			document.getElementsByClassName('header__logo')[0].getElementsByTagName('img')[0].setAttribute('src',logoUrl)

		}
	}
	lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
}

  
function goPage( num, object ){
      
	if(object != undefined){
		$( ".paginator a" ).removeClass( "active" );
		$( object ).addClass( "active" );
	}
	
	var first_item = items_by_page * num;
	var last_item = first_item + items_by_page;
	$.each( $( ".offers-search__col.div" ), function( index, value ){

		if( index < first_item )
			$( value ).css( "display", "none" );
		else if( index >= first_item && index < last_item )
			$( value ).css( "display", "flex" );
		else
			$( value ).css( "display", "none" );

	} )
	const first = (num+1);
	let  lostNum = 1;
	if(first>1)
		lostNum = (num*items_by_page)+1;
	const total = $( ".offers-search__col.div" ).length;
	const length= first*items_by_page;
	

	return false;
}
 
function generatePaginator(){

	$( ".paginator" ).remove();

	var count = $('.offers-search__col.div').length;
	var html = "<div class='paginator'>";
	var floor = count/items_by_page;
	if(count>items_by_page){
		for( var i = 0 ; i <  floor ; i++ ){
			html += "<a href='#result-list' ";
			if(i == 0) { html += 'class="active"';}
			html += " onclick='goPage("+i+", this)'>" + (i+1) + "</a> ";
		}
	}
	html += "<div>";

	$( "#result-list" ).append( html ); 
}

function removeDuplicateHtml(names,type){
	let uniqueNames = [];
	let html 		= '';
	//Remove Duplicates.
	$.each(names, function(i, el){
		if($.inArray(el, uniqueNames) === -1) uniqueNames.push(el);
	});
	//Sort alphabetically.
	uniqueNames.sort(function(a, b){
		if(a < b) { return -1; }
		if(a > b) { return 1; }
		return 0;
	})
	//write result by type of field.
	switch (type) {
		case 'li':
			uniqueNames.forEach(element => {
				let this_class =  element.replace(/ /g, '_');
				this_class = this_class.replace('.', '-');
				html += '<li data-filter="'+this_class+'">'+element+'</li>';
			});
			break;
	
		default:
			uniqueNames.forEach(element => {
				let this_class =  element.replace(/ /g, '_');
				this_class = this_class.replace('.', '-');
				html += '<option data-filter="'+this_class+'" value="'+element+'">'+element+'</option>';
			});
			break;
	}

	return html;
}

function onloadReserve(){
    let hash = window.location.hash.replace('#','');
    if(hash.length>0 && $('.offers-search__col').length>0){
        $('.offers-search__item[data-key='+hash+']').trigger('click');
    }
}



//vanilla js scroll TO animation ----------------------------------------------------------------
function animateTo(target) {
	var gotoTarget = offset(document.getElementById(target)).top - 250;
	var from = window.pageYOffset;
	var to = gotoTarget;
	var duration = 1300;
	var start = new Date().getTime();

	//time interval
	var timer = setInterval(function () {
		var time = new Date().getTime() - start;

		if (from <= to) {
			var y = easeInOutQuart(time, from, to - from, duration);
		} else {
			var y = easeInOutQuart(time, from, -(from - to), duration);
		}
		window.scrollTo(0, y);
		if (time >= duration) clearInterval(timer);
	}, 1000 / 60);

	window.scrollTo(0, from);
}
// Ease movement ----------------------------------------------------------------
function easeInOutQuart(t, b, c, d) {
	if ((t /= d / 2) < 1) return (c / 2) * t * t * t * t + b;
	return (-c / 2) * ((t -= 2) * t * t * t - 2) + b;
}
function offset(el) {
	var rect = el.getBoundingClientRect(),
		scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
		scrollTop = window.pageYOffset || document.documentElement.scrollTop;
	return { top: rect.top + scrollTop, left: rect.left + scrollLeft };
}

